/**
 * Color utility functions
 */
import { USER_COLORS } from '../config.js';

let userColorIndex = 0;

/**
 * Get the next user color from the palette
 * @returns {number} Color hex value
 */
export function getNextUserColor() {
  const color = USER_COLORS[userColorIndex];
  userColorIndex = (userColorIndex + 1) % USER_COLORS.length;
  return color;
}

/**
 * Reset the user color index
 */
export function resetUserColorIndex() {
  userColorIndex = 0;
}

/**
 * Convert color number to hex string
 * @param {number} color - Color as number
 * @returns {string} Hex color string
 */
export function colorToHex(color) {
  return `#${Number(color).toString(16).padStart(6, '0')}`;
}
